import { ISection } from "../../model/formconfiguration/Section";
import { IFormSectionService } from "../../service/formconfiguration/FormSectionService";

export default class UpdateFormSectionInteractor {
  private formSectionService: IFormSectionService;

  constructor(formSectionService) {
    this.formSectionService = formSectionService;
  }

  async execute(section: ISection) {
    return this.formSectionService.updateFormSection(section);
  }
}
